import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "export",
  "use": "export-usage",
  "viewBox": "0 0 640 640",
  "content": "<symbol viewBox=\"0 0 640 640\" id=\"export\"><path d=\"M480 480H64V192h83.04s22.048-28.672 69.44-64H32c-17.696 0-32 14.368-32 32v352c0 17.696 14.304 32 32 32h480c17.696 0 32-14.304 32-32V392.128l-64 52.64V480zm-52.448-222.4v113.632L640 204.8 427.552 44.832v100.192C169.6 145.024 169.6 400 169.6 400c73.024-119.936 117.952-142.4 257.952-142.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/export.svg
// module id = GHP0
// module chunks = 1